import React, { useState, useEffect } from 'react';
import { Container, Card, Alert } from 'react-bootstrap';
import { useSearchParams, Link } from 'react-router-dom';

const GoCardlessSuccess = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [customerInfo, setCustomerInfo] = useState(null);

  useEffect(() => {
    const email = searchParams.get('customer_email');
    if (email) {
      checkCustomerStatus(email);
    } else {
      setStatus('error');
    }
  }, [searchParams]);

  const checkCustomerStatus = async (email) => {
    try {
      const response = await fetch(`/api/gocardless/status/${encodeURIComponent(email)}`);
      const data = await response.json();

      if (response.ok) {
        setCustomerInfo(data);
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Error checking customer status:', error);
      setStatus('error');
    }
  };

  if (status === 'loading') {
    return (
      <Container className="my-5">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Checking your Direct Debit setup status...</p>
        </div>
      </Container>
    );
  }

  if (status === 'error') {
    return (
      <Container className="my-5">
        <Card className="shadow">
          <Card.Header className="bg-danger text-white text-center">
            <h3 className="mb-0">Setup Error</h3>
          </Card.Header>
          <Card.Body className="p-4 text-center">
            <Alert variant="danger">
              <h5>Something went wrong</h5>
              <p>We couldn't verify your Direct Debit setup. Please contact support for assistance.</p>
            </Alert>
            <Link to="/" className="btn btn-primary">
              Return to Home
            </Link>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  return (
    <Container className="my-5">
      <Card className="shadow">
        <Card.Header className="bg-success text-white text-center">
          <h3 className="mb-0">Direct Debit Setup Complete!</h3>
        </Card.Header>
        <Card.Body className="p-4">
          <div className="text-center mb-4">
            <div className="mb-3">
              <i className="fas fa-check-circle text-success" style={{ fontSize: '3rem' }}></i>
            </div>
            <h4>Welcome to Taxi-Local!</h4>
            <p className="text-muted">
              Your Direct Debit has been set up successfully and your account has been created.
            </p>
          </div>

          {customerInfo && (
            <div className="mb-4">
              <h5>Account Details:</h5>
              <ul className="list-unstyled">
                <li><strong>Name:</strong> {customerInfo.name}</li>
                <li><strong>Email:</strong> {customerInfo.email}</li>
                <li><strong>Status:</strong> 
                  <span className={`badge ${customerInfo.subscriptionStatus === 'active' ? 'bg-success' : 'bg-warning'} ms-2`}>
                    {customerInfo.subscriptionStatus === 'active' ? 'Active' : 'Pending Activation'}
                  </span>
                </li>
              </ul>
            </div>
          )}

          <Alert variant="info">
            <h6>Next Steps:</h6>
            <ol className="mb-0">
              <li>Check your email for login instructions</li>
              <li>Click the link in the email to set your password</li>
              <li>Log in to your account and start using Taxi-Local</li>
            </ol>
          </Alert>

          <div className="text-center">
            <Link to="/login" className="btn btn-primary me-2">
              Go to Login
            </Link>
            <Link to="/" className="btn btn-outline-secondary">
              Return to Home
            </Link>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default GoCardlessSuccess; 